import { getSafeAuthConfig, configureCustomAuthDefaults } from './Auth.js';

export default (function(w, d) {
  // Public API methods
  var _actions = {
      setfieldvalues: function(target, msg) {
        var flds = msg.payload;
        _.each(flds, function(val, fld) {
          if (val && fld) {
            var $fld = $('#' + fld);
            if ($fld.hasClass('selectized')) {
              $fld[0].selectize.setValue(val);
            } else {
              $fld.val(val);
            }
          }
        });
      },

      // Navigate to a state from parent page
      navigate: function(target, msg) {
        var _pld = msg.payload || null,
          stateName;
        if (_pld && 'undefined' !== typeof _pld.page) {
          stateName = isNaN(_pld.page) ? _pld.page : flowJSON.states[parseInt(_pld.page)].name;
          NGX.App.api.action('route:' + stateName);
        }
      },

      // Show display item
      showitem: function(target, msg) {
        var _pld = msg.payload || null,
          _type = _pld.type || 'item';
        NGX.App.api.action('display:' + _type + ':' + _pld.itemId);
      },

      // Set positioning info in page display context
      returnpageinfo: function(target, msg) {
        NGX.App.state.pageInfo = msg.payload || {};
      },

      // Trigger an event
      triggerevent: function(target, msg) {
        NGX.App.Events.trigger(msg.payload.event, msg.payload);
      },

      // Auth related actions:
      getuser: function(target, msg) {
        var user = NGX.User.get({ filterExternal: true });
        NGX.App.api.messageParent({
          action:     'event',
          event:      'auth:user:get',
          callbackId: msg.msgId,
          payload:    { user: user },
        });
      },
      getauthconfig: function(target, msg) {
        var authConfig = getSafeAuthConfig();
        NGX.App.api.messageParent({
          action:     'event',
          event:      'auth:config:get',
          callbackId: msg.msgId,
          payload:    { config: authConfig },
        });
      },
      enablecustomauth: function(target, msg) {
        //  Set some sensible defaults.
        var authConfig = configureCustomAuthDefaults();

        // Override with message params if set.
        var payload = msg.payload;
        var config = payload ? payload.config : null;
        if (payload && config) {
          // Set display property.
          if (config.display) {
            authConfig.display = config.display;
          }
          // Set enforcement property.
          if (config.enforcement) {
            authConfig.enforcement = config.enforcement;
          }
        }

        // Init auth.
        NGX.Auth.init(authConfig);

        NGX.App.api.messageParent({
          action:     'event',
          event:      'auth:enable:custom',
          callbackId: msg.msgId,
          payload:    { config: authConfig },
        });
      },

      // Resize.
      resize: function(target, msg) {
        NGX.App.api.resizeParent();
      },

      // Send the customer id back to the customer's iframe parent page
      getcustomerid: function(frame, msg) {
        var custId = NGX.App.api.getCustomerID();
        NGX.App.api.messageParent({
          action:     'event',
          event:      'getcustomerid',
          callbackId: msg.msgId,
          payload:    { customerid: custId },
        });
      },

      // Get the customer id from the iframe parent page, set it via the api.
      setcustomerid: function(frame, msg) {
        NGX.App.api.setCustomerID(msg.payload.customerid, msg.payload.customeridtype);
      },

      // Get the customer's privacy / cookie consents from the iframe parent page, set it via the api.
      setprivacyconsents: function(frame, msg) {
        NGX.App.api.setPrivacyConsents(msg.payload.consentSettings);
      },
    },
    enableListeners = function() {
      if (w.addEventListener) {
        w.addEventListener('message', receiveMessage, false);
        w.addEventListener('resize', _.debounce(NGX.App.api.resizeParent, 250), false);
      } else {
        w.attachEvent('onmessage', receiveMessage);
        w.attachEvent('onresize', _.debounce(NGX.App.api.resizeParent, 250));
      }
    },
    disableListeners = function() {
      if (w.removeEventListener) {
        w.addEventListener('message', receiveMessage, false);
        w.addEventListener('resize', _.debounce(NGX.App.api.resizeParent, 250), false);
      } else {
        w.detachEvent('onmessage', receiveMessage);
        w.detachEvent('onresize', _.debounce(NGX.App.api.resizeParent, 250));
      }
    },
    registerEventHandler = function(event, fn) {
      if ('function' === typeof fn) {
        NGX.Embed.eventHandlers[event || '*'] = fn;
      }
    };

  // Internal methods
  function isValidMessage(msg) {
    return msg && typeof msg.data === 'string' && msg.data.indexOf('_NGX_') === 0;
  }

  /**
   * Parses a message, dispatches the action and triggers a callback if given
   * @param e
   */
  function receiveMessage(e) {
    try {
      log.debug('Message Received: ' + e.data, 10);
      // Ensure we're trying to parse an Engage message and not one from a different SDK
      if (isValidMessage(e)) {
        // Parse the message as JSON
        var msgObj = JSON.parse(e.data.substring(5));
        if (msgObj && msgObj.hasOwnProperty('callbackId')) {
          var cbID = msgObj.callbackId;
          log.debug('Check for callback: ' + cbID, 6);

          // Check for a callback registered against the received message
          if (
            NGX.App.state.callbackQueue.hasOwnProperty(cbID) &&
            'function' === typeof NGX.App.state.callbackQueue[cbID]
          ) {
            log.debug('We have a callback, invoke it and remove it', 6);

            NGX.App.state.callbackQueue[cbID].call(this, msgObj.payload);
            delete NGX.App.state.callbackQueue[cbID];
          }
        } else {
          var result;
          if ((result = messageAction(msgObj)) && e.source) e.source.postMessage(result, '*');
        }
      }
    } catch (e) {
      log.debug('Message Received exception occured: ', 10);
      log.debug(e, 10);
    }
  }

  function messageAction(msg) {
    // Attempt to retrieve the iframe from a message's ID
    var getIframeFromMessage = function(msg) {
      var _msgId = msg.id,
        _compoundId,
        _compoundIdParts,
        _guidId,
        _intId;

      if (!_msgId) return false;

      _compoundId = _msgId.substring(8); // ngxFrame == 8 chars
      _compoundIdParts = _compoundId.split(':');
      _guidId = _compoundIdParts[0];
      _intId = _compoundIdParts[1];

      const guidFrame = d.getElementById('ngxFrame' + _guidId);
      const intFrame = d.getElementById('ngxFrame' + _intId);

      if (guidFrame) {
        return guidFrame;
      } else if (intFrame) {
        return intFrame;
      }

      return undefined;
    };

    var theFrame = getIframeFromMessage(msg),
      result;

    if (msg.action === 'event') {
      // See if there's an event handler, and trigger it if found
      if (NGX.Embed.eventHandlers.hasOwnProperty(msg.event.toLowerCase())) {
        NGX.Embed.eventHandlers[msg.event.toLowerCase()].call(this, msg.event, msg.payload, msg.msgId);
      }
    } else {
      if (_actions.hasOwnProperty(msg.action.toLowerCase())) {
        return _actions[msg.action.toLowerCase()].call(this, theFrame, msg);
      }
    }
  }

  function init() {
    // Just turn on the listeners
    NGX.Embed.listen();
  }

  return {
    eventHandlers: {},
    init:          init,
    listen:        enableListeners,
    ignore:        disableListeners,
    actions:       _actions,
    sendMessage:   function(message, callback) {
      return NGX.App.api.messageParent(message, callback);
    },
    registerEventHandler: registerEventHandler,
  };
})(window, document);
